function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5977 23.1272C15.5977 19.7701 18.3191 17.0486 21.6763 17.0486H126.091C129.448 17.0486 132.17 19.7701 132.17 23.1272V126.022C132.17 129.379 129.448 132.101 126.091 132.101H21.6763C18.3191 132.101 15.5977 129.379 15.5977 126.022V23.1272Z",
  fill: "#D8F1E5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M142.069 108.594C141.816 108.634 141.555 108.655 141.288 108.655H139.996V110.839H141.288C141.669 110.839 142.043 110.809 142.409 110.752L142.069 108.594ZM145.323 106.599C145.015 107.022 144.642 107.396 144.218 107.704L145.504 109.47C146.112 109.027 146.647 108.492 147.089 107.885L145.323 106.599ZM148.459 103.669V102.596H146.274V103.669C146.274 103.935 146.254 104.196 146.214 104.45L148.371 104.789C148.429 104.423 148.459 104.049 148.459 103.669ZM146.274 97.2353V99.3797H148.459V97.2353H146.274ZM146.274 91.8742V94.0187H148.459V91.8742H146.274ZM146.274 86.5132V88.6576H148.459V86.5132H146.274ZM146.274 81.1521V83.2965H148.459V81.1521H146.274ZM146.274 75.7918V77.9362H148.459V75.7918H146.274ZM146.274 70.4307V72.5751H148.459V70.4307H146.274ZM146.274 65.0696V67.2141H148.459V65.0696H146.274ZM146.274 59.7086V61.853H148.459V59.7086H146.274ZM146.274 54.3475V56.4919H148.459V54.3475H146.274ZM146.274 48.9864V51.1309H148.459V48.9864H146.274ZM146.274 43.6254V45.7698H148.459V43.6254H146.274ZM146.274 38.2643V40.4087H148.459V38.2643H146.274ZM146.274 32.9032V35.0477H148.459V32.9032H146.274ZM146.274 27.5429V29.6873H148.459V27.5429H146.274ZM146.274 22.1818V24.3263H148.459V22.1818H146.274ZM52.0562 16.8675V19.0223H54.2407V16.8675H52.0562ZM146.274 16.8208V18.9652H148.459V16.8208H146.274ZM52.0562 11.4805V13.6353H54.2407V11.4805H52.0562ZM146.274 11.4597V13.6041H148.459V11.4597H146.274ZM54.2407 7.17085C54.2407 6.90433 54.2617 6.64345 54.3016 6.3895L52.1438 6.0504C52.0863 6.41612 52.0562 6.79036 52.0562 7.17085V8.24825H54.2407V7.17085ZM148.459 7.17085C148.459 6.79036 148.429 6.41612 148.371 6.0504L146.214 6.3895C146.254 6.64345 146.274 6.90433 146.274 7.17085V8.24306H148.459V7.17085ZM144.218 3.13576C144.642 3.44385 145.015 3.8173 145.323 4.24062L147.089 2.95471C146.647 2.34719 146.112 1.81194 145.504 1.36976L144.218 3.13576ZM55.0109 1.36976C54.4034 1.81194 53.8682 2.34719 53.426 2.95471L55.192 4.24062C55.5001 3.8173 55.8735 3.44385 56.2968 3.13576L55.0109 1.36976ZM140.194 0V2.1845H141.288C141.555 2.1845 141.816 2.20545 142.069 2.24534L142.409 0.0875579C142.043 0.0300986 141.669 0 141.288 0H140.194ZM59.2271 0C58.8466 0 58.4723 0.0300986 58.1066 0.0875579L58.4457 2.24534C58.6997 2.20545 58.9605 2.1845 59.2271 2.1845H60.3215V0H59.2271ZM134.724 0V2.1845H136.912V0H134.724ZM129.253 0V2.1845H131.441V0H129.253ZM123.782 0V2.1845H125.97V0H123.782ZM118.311 0V2.1845H120.499V0H118.311ZM112.84 0V2.1845H115.029V0H112.84ZM107.37 0V2.1845H109.558V0H107.37ZM101.899 0V2.1845H104.087V0H101.899ZM96.4281 0V2.1845H98.6163V0H96.4281ZM90.9572 0V2.1845H93.1454V0H90.9572ZM85.4863 0V2.1845H87.6752V0H85.4863ZM80.0161 0V2.1845H82.2043V0H80.0161ZM74.5452 0V2.1845H76.7335V0H74.5452ZM69.0744 0V2.1845H71.2626V0H69.0744ZM63.6035 0V2.1845H65.7917V0H63.6035Z",
  fill: "#003311"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.0562 24.3411V22.1863H54.2407V24.3411H52.0562Z",
  fill: "#003311"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M52.0562 29.6599V27.5051H54.2407V29.6599H52.0562Z",
  fill: "#003311"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M134.83 110.825V108.68H137.014V110.825H134.83Z",
  fill: "#003311"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M150.79 33.7648H143.188V41.3677H150.79V33.7648Z",
  fill: "#22EE88",
  stroke: "#003311",
  strokeWidth: 2.27947,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0.720703 85.463C0.720703 56.0215 24.6266 32.1156 54.068 32.1156C83.5164 32.1156 107.415 56.0215 107.415 85.463C107.422 114.911 83.5164 138.817 54.075 138.817C24.6266 138.817 0.720703 114.911 0.720703 85.463Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M82.4512 122.889L90.1982 115.471L99.7647 125.625L92.0107 133.043L82.4512 122.889Z",
  fill: "#00AA55"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M92.1497 132.428L99.085 125.793C100.247 124.681 102.101 124.737 103.193 125.912L131.487 156.138C132.613 157.348 132.557 159.238 131.361 160.386L124.628 166.831C123.411 168 121.465 167.944 120.318 166.705L92.0308 136.487C90.96 135.332 91.009 133.526 92.1497 132.435V132.428Z",
  fill: "#22EE88"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5217 122.35C35.8935 143.639 69.6598 144.387 90.9553 124.016C112.244 103.644 112.993 69.8776 92.6209 48.582C72.2491 27.2935 38.4828 26.5447 17.1873 46.9165C-4.10127 67.2882 -4.85008 101.055 15.5217 122.35ZM21.8201 51.7522C40.4423 33.9418 69.9747 34.5926 87.7851 53.2149C105.596 71.8371 104.945 101.369 86.3225 119.187C67.7003 136.997 38.1679 136.347 20.3575 117.724C2.54702 99.1021 3.19786 69.5697 21.8201 51.7522Z",
  fill: "#003311"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 76.2012,
  y: 61.0139,
  width: 7.23136,
  height: 65.9862,
  transform: "rotate(45 76.2012 61.0139)",
  fill: "#00AA55"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 29.541,
  y: 66.1273,
  width: 7.23136,
  height: 65.9862,
  transform: "rotate(-45 29.541 66.1273)",
  fill: "#00AA55"
});

var SvgNoResults = function SvgNoResults(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 178,
    viewBox: "0 0 152 178",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoResults, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-results.ac8708dd.svg";
export { ForwardRef as ReactComponent };